import { defineStore } from 'pinia';
import { v4 as uuidv4 } from 'uuid';
import { ref } from 'vue';

export const useToastStore = defineStore('toast', () => {

  const toasts = ref([]);

  function $reset() {
    toasts.value = [];
  }

  function add(type, message) {
    toasts.value.push({
      id: uuidv4(),
      type: type,
      message: message,
    });
  }

  function remove(id) {
    toasts.value = toasts.value.filter(toast => toast.id !== id);
  }

  return {
    add,
    remove,
    toasts,
    $reset,
  };
});
